import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { createId } from '@core/util/file';
import { FolderBreadcrumbs } from '@core/util/folder';
import { DefaultFolder, Folder, MatterFileType } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BusinessFoldersState } from '@state/business/folders/folders.state';

export interface TemplateFolderEditDialogData {
	author: string;
	currentFolder?: Folder;
	folder?: Folder;
	matterFileTypes: MatterFileType[];
	parentId: string;
	showMatterTypes: MatterFileType[];
}

export type TemplateFolderEditDialogClose = Folder;

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-template-folder-dialog',
	templateUrl: 'template-folder-edit-dialog.component.html',
	standalone: false,
})
export class TemplateFolderEditDialogComponent implements OnInit {
	addEdit: 'Add' | 'Edit';
	breadcrumbs: Folder[];
	folder: Folder;
	@SelectSnapshot(BusinessFoldersState.getAll) folders: Folder[];

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: TemplateFolderEditDialogData,
		private dialogRef: MatDialogRef<TemplateFolderEditDialogComponent>,
	) {}

	ngOnInit(): void {
		this.addEdit = this.data.folder ? 'Edit' : 'Add';
		this.breadcrumbs = FolderBreadcrumbs(
			this.data.currentFolder?.id ?? this.data.folder?.id,
			this.folders,
		).map((folderId) => this.folders.find((folder) => folder.id === folderId));
		this.folder = {
			...DefaultFolder,
			...this.data.folder,
			author: this.data.author
				? this.data.author
				: this.data.folder
					? this.data.folder.author
					: DefaultFolder.author,
			createdAt: this.data.folder ? this.data.folder.createdAt : Date.now(),
			id: this.data.folder ? this.data.folder.id : createId(),
			matterType: this.data.matterFileTypes
				? this.data.matterFileTypes
				: this.data.folder
					? this.data.folder.matterType
					: DefaultFolder.matterType,
			parentId: this.data.parentId
				? this.data.parentId
				: this.data.folder
					? this.data.folder.parentId
					: DefaultFolder.parentId,
		};
	}

	cancelModal(): void {
		this.dialogRef.close();
	}

	saveFolder(): void {
		const data: TemplateFolderEditDialogClose = this.folder;
		this.dialogRef.close(data);
	}
}
